const VideoRoute = () => {
  return (
    <div style={{width:"100vw",height:"100dvh",display:"flex",justifyContent:"center",alignItems:'center'}}>
      <video width="100%" height="100%" controls>
        <source src="assets/chatbudddies.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoRoute;
